import { LanguageContext } from './LanguageContext';
import { IntlProvider } from 'react-intl';
import { ReactNode, useEffect, useState } from 'react';

/* eslint-disable-next-line */
const en = require('./lib/en.json');
/* eslint-disable-next-line */
const bn = require('./lib/bn.json');

/* eslint-disable-next-line */
export interface LocalizeProps {
  children: ReactNode;
}

const langdb = {
  en,
  bn,
};

export function Localize(props: LocalizeProps) {
  const [language, setLanguage] = useState<string>('en');

  /* eslint-disable-next-line */
  const [messages, setMessages] = useState<any>();

  useEffect(() => {
    if (language && langdb) {
      setMessages(langdb[language]);
    }
  }, [language]);

  const getTranslation = (key: string) => {
    return messages[key];
  };

  return (
    <LanguageContext.Provider
      value={{
        messages: langdb && langdb[language],
        changeLanguage: (language) => setLanguage(language),
        getTranslation: getTranslation,
      }}
    >
      <IntlProvider locale={language} messages={messages}>
        {messages ? props.children : null}
      </IntlProvider>
    </LanguageContext.Provider>
  );
}

export default Localize;
